import Vue from 'vue'
import Vuex from 'vuex'
import { login, dataReport, etcd, home, advertise, subAccountGlobal, operationLog } from '@/global/store'
import financial from './modules/financial'
import advertiser from './modules/advertiser'
// import subAccount from '@/agent/store/modules/subAccount'
import subAccount from './modules/subAccount'
import order from './modules/order'
import managerAdvertise from './modules/advertise'
import traffic from './modules/traffic'
import audience from './modules/audience'
import fallbackAd from './modules/fallbackAd'
// import accountInfo from '../../agent/store/modules/accountInfo';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    home: {
      namespaced: true,
      ...home
    },
    login: {
      namespaced: true,
      ...login
    },
    etcd: {
      namespaced: true,
      ...etcd
    },
    dataReport: {
      namespaced: true,
      ...dataReport
    },
    advertiser: {
      namespaced: true,
      ...advertiser
    },
    finance: {
      namespaced: true,
      ...financial
    },
    subAccount: {
      namespaced: true,
      ...subAccount
    },
    fallbackAd: {
      namespaced: true,
      ...fallbackAd
    },
    order,
    global: {
      namespaced: true,
      modules: {
        advertise: {
          namespaced: true,
          ...advertise
        },
        subAccount: {
          namespaced: true,
          ...subAccountGlobal
        },
        operationLog: {
          namespaced: true,
          ...operationLog
        }
      }
    },
    advertise: {
      namespaced: true,
      ...managerAdvertise
    },
    traffic: {
      namespaced: true,
      ...traffic
    },
    audience: {
      namespaced: true,
      ...audience
    }
  }
})
